/**
 * Nimizo × Trustyy star ratings — PDP + product cards under titles.
 * Uses Trustyy Reviews API; always renders Nimizo horizontal coral stars
 * (Trustyy's stock badge can stack stars vertically / use yellow).
 */
(function () {
  var API = 'https://apps.trustyyapp.com';
  var CORAL = '#FF6B81';
  var EMPTY = '#FFD0D7';
  var STAR_PATH =
    'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63L2 9.24l5.46 4.73L5.82 21z';
  var cache = Object.create(null);

  function shopSlug(shop) {
    return String(shop || '')
      .replace(/^https?:\/\//i, '')
      .replace(/\.myshopify\.com$/i, '')
      .split('/')[0];
  }

  function apiUrl(shop, handle) {
    var domain = shopSlug(shop);
    return (
      API +
      '/api/getReviewsData/' +
      encodeURIComponent(JSON.stringify(domain)) +
      '/' +
      encodeURIComponent(JSON.stringify(handle)) +
      '/' +
      encodeURIComponent('date desc') +
      '/1'
    );
  }

  function starSvg(fill, size) {
    size = size || 16;
    return (
      '<svg xmlns="http://www.w3.org/2000/svg" height="' +
      size +
      '" width="' +
      size +
      '" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path fill="' +
      fill +
      '" d="' +
      STAR_PATH +
      '"></path></svg>'
    );
  }

  function starsHtml(avg, size) {
    var rating = Number(avg) || 0;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += starSvg(rating >= i - 0.25 ? CORAL : EMPTY, size);
    }
    return html;
  }

  function renderBadge(el, data) {
    if (!el) return;
    var reviews = (data && data.reviewsData) || {};
    var avg = reviews.avgRating;
    var count = Number(reviews.length) || 0;
    var context = el.getAttribute('data-context') || 'card';
    var size = context === 'pdp' ? 18 : 14;
    var ratingNum = avg == null || avg === '' ? 0 : Number(avg);
    var label =
      count > 0
        ? (ratingNum > 0 ? ratingNum.toFixed(1) + ' · ' : '') +
          count +
          (count === 1 ? ' review' : ' reviews')
        : 'No reviews yet';

    el.innerHTML =
      '<button type="button" class="nimizo-star-rating__btn" data-nimizo-star-scroll>' +
      '<span class="nimizo-star-rating__stars" aria-hidden="true">' +
      starsHtml(ratingNum, size) +
      '</span>' +
      '<span class="nimizo-star-rating__text">' +
      label +
      '</span>' +
      '</button>';

    el.removeAttribute('data-loading');
    el.setAttribute('data-nimizo-star-rendered', '1');
  }

  function fetchRating(shop, handle) {
    var key = shopSlug(shop) + '::' + handle;
    if (cache[key]) return cache[key];
    cache[key] = fetch(apiUrl(shop, handle), { credentials: 'omit' })
      .then(function (res) {
        return res.json();
      })
      .then(function (payload) {
        return (payload && payload.result) || {};
      })
      .catch(function () {
        return { reviewsData: { avgRating: 0, length: 0 } };
      });
    return cache[key];
  }

  function initEl(el) {
    if (!el || el.dataset.nimizoStarReady === '1') return;
    el.dataset.nimizoStarReady = '1';
    el.setAttribute('data-loading', 'true');

    var shop = el.getAttribute('data-shop') || (window.Shopify && window.Shopify.shop) || '';
    var handle = el.getAttribute('data-handle');
    if (!handle) return;

    fetchRating(shop, handle).then(function (data) {
      renderBadge(el, data);
    });
  }

  function run() {
    document.querySelectorAll('[data-nimizo-star-rating]').forEach(initEl);
  }

  /* If Trustyy (or anything) rewrites our badge, put it back. */
  function guardRendered(el) {
    if (!el || el.getAttribute('data-nimizo-star-rendered') !== '1') return;
    if (el.querySelector('.nimizo-star-rating__btn')) return;
    var shop = el.getAttribute('data-shop') || (window.Shopify && window.Shopify.shop) || '';
    var handle = el.getAttribute('data-handle');
    if (!handle) return;
    fetchRating(shop, handle).then(function (data) {
      renderBadge(el, data);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-nimizo-star-scroll]');
    if (!btn) return;
    var target =
      document.getElementById('Itgeekscarousel') ||
      document.querySelector('.nimizo-apps--reviews, [id*="tra_review"], #Itg-testimonial-section');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      run();
      document.querySelectorAll('[data-nimizo-star-rating]').forEach(guardRendered);
    });
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  var obs = new MutationObserver(schedule);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
